import Branded from './Branded';

export default Branded;
